import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import "./i18n";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "./auth/AuthContext";
import { ThemeProvider } from "./theme/ThemeProvider";
import { isMockModeActive } from "./mock/mock-mode";

// Ant Design + Chrome can emit a benign ResizeObserver error that CRA's overlay treats as fatal.
const isResizeObserverNoise = (message: string | undefined) =>
  !!message &&
  (message.includes(
    "ResizeObserver loop completed with undelivered notifications",
  ) ||
    message.includes("ResizeObserver loop limit exceeded"));

window.addEventListener(
  "error",
  (event) => {
    if (isResizeObserverNoise(event.message)) {
      event.stopImmediatePropagation();
      event.preventDefault();
    }
  },
  true,
);

const OriginalResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends OriginalResizeObserver {
  constructor(callback: ResizeObserverCallback) {
    super((entries, observer) => {
      window.requestAnimationFrame(() => {
        callback(entries, observer);
      });
    });
  }
};

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
const mockActive = isMockModeActive();

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider>
        {mockActive ? (
          <App />
        ) : (
          <AuthProvider>
            <App />
          </AuthProvider>
        )}
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
